<template>
  <!--INSTRUCTION-->
  <div class="instruction" v-if="loaded && instructions">
    <div v-if="instructions.appointmentText" class="appointment-text">
      <span v-if="toggleText" v-html="instructions.appointmentTextHelp"></span>
      <span v-else v-html="instructions.appointmentText"></span>
      <br />
      <hr />
      <br />
    </div>

    <DisplayText
      :screenProperties="screenProperties"
      :isInstruction="true"
      :instructions="instructions"
    ></DisplayText>

    <br />

    <!--Arrow-->
    <span class="route">{{ instructions.route }}</span>
    <div v-if="instructions.enableImage" class="image-container scan-media">
      <div class="image-decorator">
        <img :src="instructions.imageUrl" />
      </div>
    </div>
    <div v-else>
      <svg
        v-if="instructions && instructions.arrowDegrees !== null"
        id="directionArrow"
        width="10vw"
        height="10vw"
        viewBox="0 0 24 24"
        :fill="instructions.routeColor"
        stroke="none"
        :transform="'rotate(' + instructions.arrowDegrees + ')'"
      >
        <path d="M 7,11 H 1 L 12,0 23,11 H 17 V 24 H 7 Z" />
      </svg>
    </div>
  </div>

  <div class="buttons" v-show="close !== ''">
    <button
      class="btn buttons pointer close"
      :disabled="disableButtons"
      @click="closeInstruction({ id: 'closeInstruction' })"
    >
      {{ close }}
    </button>
    <i class="fa fa-hand-point-right text-color fa-3x hand-pointer-instruction"></i>
  </div>

  <div
    class="ticket-warning"
    v-if="
      instructions?.tickets?.length > 0 &&
      instructions.tickets[0]?.data &&
      ticketWarning !== ''
    "
  >
    {{ ticketWarning }}
    <br/>
    <svg
      id="directionArrow"
      width="4vh"
      height="4vh"
      viewBox="0 0 24 24"
      :fill="arrowColor"
      stroke="none"
      transform="rotate(130)"
    >
      <path d="M 7,11 H 1 L 12,0 23,11 H 17 V 24 H 7 Z"/>
    </svg>
  </div>
</template>

<script>
import store from "@/store";
import screenService from "@/services/screenApiService";
import DisplayText from "@/components/common/DisplayText";
import zijderoute from "@/services/zijderoute";
import { mapState } from "vuex";

const sound = require("@/assets/eID-vergeten.mp3");
const toTranslate = ["close", "ticketWarning"];

export default {
  name: "Instruction",
  components: { DisplayText },
  data() {
    return {
      instructions: {},
      screenProperties: {},
      loaded: false,
      close: "",
      ticketWarning: "",
      cardChecked: false,
      idleTimeoutForCountdown: null,
      arrowColor: "#fff",
    };
  },
  computed: mapState(["toggleText", "disableButtons", "showTimerPopup"]),
  watch: {
    showTimerPopup(newValue) {
      if (newValue === false) {
        // print ticket once timer popup disappears
        this.printTicket();
      }
    },
    toggleText(newValue) {
      if (store.state.languageId !== store.state.defaultLanguage.id) {
        if (newValue === true) {
          this.getTranslation(store.state.defaultLanguage.id, toTranslate);
        } else if (newValue === false) {
          this.getTranslation(store.state.languageId, toTranslate);
        }
      }
    },
  },
  mounted() {
    this.screenProperties = store.state.currentScreenProperties;
    this.instructions = store.state.currentScreenInstructions;
    this.getTranslation(store.state.languageId, toTranslate);
    this.arrowColor =
      store.state.siteTheme.secondaryColor &&
      store.state.siteTheme.secondaryColor
        ? store.state.siteTheme.secondaryColor
        : "#fff";
    this.loaded = true;
    if (!this.showTimerPopup) {
      // print ticket only if there is no timer popup
      this.printTicket();
    }
    zijderoute.onLoad();

    // Clears the existing timeout
    if (this.idleTimeoutForCountdown)
      clearTimeout(this.idleTimeoutForCountdown);
    // Set timeout to redirect after timeOut seconds
    this.idleTimeoutForCountdown = setTimeout(() => {
      this.closeInstruction({ id: "automaticRedirect" });
    }, this.screenProperties.timeOut * 1000);

    if (this.instructions.enableImage) {
      // for dividing screen in landscape mode
      document.getElementById('inner').classList.add('landscape-inner');
    }
  },
  beforeUnmount() {
    // Clears the existing timeout
    if (this.idleTimeoutForCountdown)
      clearTimeout(this.idleTimeoutForCountdown);
    zijderoute.offLoad();
    document.getElementById('inner').classList.remove('landscape-inner');
  },
  methods: {
    getTranslation(lang = store.state.languageId, keys) {
      let app = this;
      if (lang) {
        keys.forEach(function (key) {
          screenService
            .getTranslation(lang, "fe." + key)
            .then(function (response) {
              app[key] = response.data;
            })
            .catch(function () {
              console.log(
                "No translation found for fe." + key + " in language " + lang
              );
              app[key] = "-";
            });
        });
      }
    },
    printTicket() {
      // TO DO: check printer status first
      let tickets =
        this.instructions && this.instructions.tickets
          ? this.instructions.tickets
          : [];
      if (tickets.length > 0) {
        tickets.forEach((ticket) => {
          if (ticket === null) {
            console.log("Error: Ticket is null");
            return;
          }
          let imgUrl = ticket.data;
          let printerName = ticket.printerName;
          console.log(
            "Printing image: " + imgUrl + " on printer " + printerName
          );
          zijderoute.printImage(imgUrl, printerName, (msg) => {
            console.log(msg);
          });
        });
      }
    },
    closeInstruction(button) {
      store.state.disableButtons = true;
      this.cardChecked = false;
      if (store.state.checkForgottenEid === true) {
        this.checkCard(button);
        setTimeout(() => {
          if (this.cardChecked === false) {
            this.exitPage(button);
          }
        }, 10000);
      } else {
        this.exitPage(button);
      }
    },

    checkCard(button) {
      zijderoute.checkCard((msg) => {
        this.cardChecked = true;
        if (msg.success === true) {
          let cardPresent = msg.message.CARD_PRESENT;
          if (cardPresent === true) {
            console.log("card present");
            let audio = new Audio(sound);
            audio.play();
            store.commit("showWarning", true);
            setTimeout(() => {
              if (store.state.showWarning === true)
                store.commit("showWarning", false);
            }, 10000);
          } else {
            console.log("card not present");
          }
          this.exitPage(button);
        } else {
          console.log("Problems with checking card");
          this.exitPage(button);
        }
      });
    },

    exitPage(button) {
      let screenshot = {
        selectedButton: button,
        flowOptions: store.state.currentScreenOptions,
        screenProperties: store.state.currentScreenProperties,
        instructions: store.state.currentScreenInstructions,
        languageId: store.state.languageId,
        domaintypeId: store.state.domaintypeId,
      };
      screenService.endFlow(screenshot);
    },
  },
};
</script>

<style scoped>
.image-decorator img {
  width: 100%; /* Make images fill their grid cell */
  height: 100%; /* Maintain aspect ratio */
  object-fit: contain; /* Crop if necessary */
}

.image-decorator {
  background-color: white;
  padding: 0px;
  width: auto;
  max-width: fit-content;
  height: 45vh;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
